const ACTION_PREFIX = `@komigen/mobile-frontend/live-casino`;
export const SET_LIVE_CASINO_DATA = `${ACTION_PREFIX}/SET_LIVE_CASINO_DATA`;

export const SET_CAROUSEL_ITEMS = `${ACTION_PREFIX}/SET_CAROUSEL_ITEMS`;

export const SET_BANNER_AUTH = `${ACTION_PREFIX}/SET_BANNER_AUTH`;

export const FETCH_CASINO_ALL_GAMES_START = `${ACTION_PREFIX}/FETCH_CASINO_ALL_GAMES_START`;

export const HYDRATE_LIVE_CASINO_GAMES = `${ACTION_PREFIX}/HYDRATE_LIVE_CASINO_GAMES`;

export const INVALIDATE_LIVE_CASINO_DATA = `${ACTION_PREFIX}/INVALIDATE_LIVE_CASINO_DATA`;

export const LIVE_CASINO_FEED_SOCKET_ON_CONNECTION_OPEN = `${ACTION_PREFIX}/LIVE_CASINO_FEED_SOCKET_ON_CONNECTION_OPEN`;
export const LIVE_CASINO_FEED_SOCKET_SET_RETRY_TIMEOUT = `${ACTION_PREFIX}/LIVE_CASINO_FEED_SOCKET_SET_RETRY_TIMEOUT`;
export const LIVE_CASINO_FEED_SOCKET_ON_MESSAGE = `${ACTION_PREFIX}/LIVE_CASINO_FEED_SOCKET_ON_MESSAGE`;
export const LIVE_CASINO_FEED_SOCKET_CLOSE_CONNECTION = `${ACTION_PREFIX}/LIVE_CASINO_FEED_SOCKET_CLOSE_CONNECTION`;
